import usePendo from "hooks/usePendo";

export default function Pendo({ children }) {
  usePendo();

  return children;
}
